import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { BankingSDKConnectorsRecipientsPivot as BankingSDKConnectorsRecipientsPivotComponent } from "ui/organizms/OpenBanking";

const BankingSDKConnectorsRecipientsPivot = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Open Banking | Banking SDK Connectors Recipients Pivot'
    >
        <BankingSDKConnectorsRecipientsPivotComponent />
    </Screen>

);

export default memo(BankingSDKConnectorsRecipientsPivot);
